import { useEffect, useState } from 'react';
import './Offer_Modal.css';
import { Modal } from 'react-bootstrap';
import Enquiry_Form_Modal from '../enquiry_form_modal/Enquiry_Form_Modal';

const Offer_Modal = () => {
  const [showOffer, setShowOffer] = useState(false);
  const [showInquiry, setShowInquiry] = useState(false);

  useEffect(() => {
    setShowOffer(true); // show offer modal on load
  }, []);

  const handleCloseOffer = () => setShowOffer(false);
  const handleCloseInquiry = () => setShowInquiry(false);

  const handleApplyClick = () => {
    setShowOffer(false); // close offer modal
    setShowInquiry(true); // open inquiry modal
  };

  // eslint-disable-next-line no-undef
  const handleClose = () => setShow(false);
  return (
    <>
      <Modal show={showOffer} onHide={handleCloseOffer} centered className="offer_modal">
        <Modal.Header>
          <Modal.Title>Get Up to ₹20,000 Scholarship</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          <div className="admission_badge">
            <span className="admission_dot"></span>
            <span>ADMISSIONS OPEN</span>
            <strong>JANUARY 2027</strong>
          </div>

          <p className="mb-3">Limited Seats Available ! </p>

          <button type="submit" className="common_red_btn" onClick={handleApplyClick}>
            Apply Now
          </button>

          <p className="mt-3 mb-0">Secure Your Spot Before It’s Gone</p>
        </Modal.Body>
      </Modal>

      <Enquiry_Form_Modal show={showInquiry} onHide={handleCloseInquiry} centered />
    </>
  );
};

export default Offer_Modal;
